/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetPaymentRequestDetail200ResponseDealFreeeJournalEntriesInner
 */
export interface GetPaymentRequestDetail200ResponseDealFreeeJournalEntriesInner {
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseDealFreeeJournalEntriesInner
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentRequestDetail200ResponseDealFreeeJournalEntriesInner
     */
    'amount': number | null;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseDealFreeeJournalEntriesInner
     */
    'freeeAccountItemId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseDealFreeeJournalEntriesInner
     */
    'freeeTaxCode': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetPaymentRequestDetail200ResponseDealFreeeJournalEntriesInner
     */
    'isInvalidTaxCode': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseDealFreeeJournalEntriesInner
     */
    'invalidTaxCodeCause': GetPaymentRequestDetail200ResponseDealFreeeJournalEntriesInnerInvalidTaxCodeCauseEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetPaymentRequestDetail200ResponseDealFreeeJournalEntriesInner
     */
    'freeeMemoTags': Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseDealFreeeJournalEntriesInner
     */
    'freeeSectionId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseDealFreeeJournalEntriesInner
     */
    'freeeItemId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseDealFreeeJournalEntriesInner
     */
    'segment1TagId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseDealFreeeJournalEntriesInner
     */
    'segment2TagId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseDealFreeeJournalEntriesInner
     */
    'segment3TagId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseDealFreeeJournalEntriesInner
     */
    'description': string | null;
}

export const GetPaymentRequestDetail200ResponseDealFreeeJournalEntriesInnerInvalidTaxCodeCauseEnum = {
    qualifiedButPartDeduct: 'QUALIFIED_BUT_PART_DEDUCT',
    notQualifiedButFullDeduct: 'NOT_QUALIFIED_BUT_FULL_DEDUCT',
    preStartButPartDeduct: 'PRE_START_BUT_PART_DEDUCT',
    inconsistentDeductRate: 'INCONSISTENT_DEDUCT_RATE'
} as const;

export type GetPaymentRequestDetail200ResponseDealFreeeJournalEntriesInnerInvalidTaxCodeCauseEnum = typeof GetPaymentRequestDetail200ResponseDealFreeeJournalEntriesInnerInvalidTaxCodeCauseEnum[keyof typeof GetPaymentRequestDetail200ResponseDealFreeeJournalEntriesInnerInvalidTaxCodeCauseEnum];


